export default {
  'app.pwa.offline': '현재 오프라인입니다',
  'app.pwa.serviceworker.updated': '새로운 콘텐츠를 사용할 수 있습니다',
  'app.pwa.serviceworker.updated.hint':
    '"새로고침" 버튼을 눌러 현재 페이지를 다시 로드해주세요',
  'app.pwa.serviceworker.updated.ok': '새로고침',
};